import { Button, DialogActions } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonLeft from '../../../../../utils/buttonLeft';
import api from '../../../../../services/api';

const DeleteAnalise = ({ url, id, index }) => {
    const [activeDelete, setActiveDelete] = useState(false);
    const [open, setOpen] = useState(false);
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()

    console.log(url, id, index)

    const HandleDeleteAnalise = () => {

        setOpen(true)
        api.delete(url, { data: { 'avaliacaoAnaliticaId': id, 'userId': user._id, observacao: user?.dadosPessoais.nome } })
            .then(response => {
                // console.log(response)
                setOpen(false)
                setActiveDelete(false)

                dispatch({
                    type: 'alert',
                    payload: { alert: 'Análise apagada com sucesso' },
                });

            }).catch(err => {
                console.log(err)
                setOpen(false)
            })
    }

    return (
        <>

            {activeDelete ?

                <ButtonLeft
                    title={'Confirmar Apagar'}
                    funcao={HandleDeleteAnalise}
                    load={open}
                >
                    <Button onClick={() => setActiveDelete(!activeDelete)} size="small" color="error">Cancelar</Button>
                </ButtonLeft>
                :
                <DialogActions>
                    <Button title='Apagar' onClick={() => setActiveDelete(!activeDelete)} size="small" color="error"><DeleteIcon /></Button>
                </DialogActions>
            }
        </>
    );
}

export default DeleteAnalise;
